import React from 'react';
import { PLACEHOLDER } from '../../../utils/constant/placeHolders';
import './TableToolbar.scss';

const { PH_SEARCH_INPUT } = PLACEHOLDER;

/**
 * TableToolbar — a unified, in-card toolbar for list pages: search box on the
 * left, optional filter controls, and an optional primary action on the right.
 *
 * Pairs with <TableCard> so the toolbar sits inside the same card as the table
 * (consistent across the app). Logic stays in the parent — this is presentation
 * only; pass an `onSearch` handler and render-props/children for filters.
 *
 * @param {(value: string) => void} onSearch
 * @param {string} [searchPlaceholder]
 * @param {React.ReactNode} [leading]   controls before search (e.g. tabs)
 * @param {React.ReactNode} [filters]   filter controls (selects, date range…)
 * @param {React.ReactNode} [actions]   right-aligned action(s) (e.g. Add button)
 * @param {boolean} [showSearch=true]
 */
function TableToolbar({
  onSearch,
  searchPlaceholder = PH_SEARCH_INPUT,
  leading = null,
  filters = null,
  actions = null,
  showSearch = true,
  className = ''
}) {
  return (
    <div className={`app-table-toolbar ${className}`.trim()}>
      <div className="app-table-toolbar__left">
        {leading ? <div className="app-table-toolbar__leading">{leading}</div> : null}
        {showSearch ? (
          <div className="app-table-toolbar__search">
            <i className="icofont-search app-table-toolbar__search-icon" aria-hidden="true" />
            <input
              type="text"
              className="form-control app-table-toolbar__search-input"
              placeholder={searchPlaceholder}
              onChange={(e) => onSearch?.(e.target.value)}
            />
          </div>
        ) : null}
        {filters ? <div className="app-table-toolbar__filters">{filters}</div> : null}
      </div>
      {actions ? <div className="app-table-toolbar__actions">{actions}</div> : null}
    </div>
  );
}

export default TableToolbar;
